<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <h3 class="card-title"><b-button size="sm" v-b-toggle.accordion-1 variant="info"><i class="fa fa-filtro"></i></b-button>Filtros </h3>
            
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-form-group>
              <b-row>
                <b-col sm="3">
                    <select name="tiendaId" v-on:change="onChangeSelectCajas" v-model="filtro.tiendaId" id="tiendaId" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('tiendaId') }">
                        <option value="-1">Todos las Tiendas</option>
                        <option v-for="itemc in selectTienda" :value="itemc.value"  v-bind:key="itemc.value">
                            {{itemc.text}}
                        </option>
                    </select>           
                </b-col>
                <b-col sm="3">
                  <select name="idCaja" v-on:change="onFiltroChange" v-model="filtro.Caja" id="idCaja" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('idCaja') }">
                      <option value="0">Todos las Cajas</option>
                      <option v-for="itemc in selectCajas" :value="itemc.codigoCaja"  v-bind:key="itemc.codigoCaja">
                          {{itemc.codigoCaja}}
                      </option>
                  </select>      
                </b-col>
                <b-col sm="3">

                </b-col>
                <b-col sm="3" class="text-center">
                  <b-button title="Aplicar filtro" :class="{'btn btn-success' :filtroActivo, 'btn btn-light':!filtroActivo}" @click="aplicarFiltro()"><i :class="{'fas fa-check':filtroActivo,'fas fa-ban':!filtroActivo}"></i></b-button>
                  <b-button title="Resetear filtro" variant="primary" @click="resetFiltro()"><i class="fas fa-undo"></i></b-button>                </b-col>
              </b-row>
              <b-row>
                <b-col sm="3">
                  <select name="ordenarPor" v-on:change="onFiltroChange" v-model="filtro.ordenar" id="ordenarPor" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('ordenarPor') }">
                      <option value="0">Ordenar Por</option>
                      <option value="1">Caja</option>
                      <option value="2">Turno</option>
                      <option value="3">Forma de Pago</option>
                  </select>                                   
                </b-col>
                <b-col sm="3">
                  <select name="estatusTurno" v-on:change="onFiltroChange" v-model="filtro.estatusTurno" id="estatusTurno" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('estatusTurno') }">
                      <option value="0">Estatus Turno</option>
                      <option value="1">Abierto</option>
                      <option value="2">Cerrado</option>
                      <option value="3">Suspendido</option>
                      <option value="4">En Revisión</option>
                      <option value="5">Verificado</option>
                  </select>
                </b-col>
                <b-col sm="3">
                  <b-input-group size="sm" prepend="NroTurno">
                    <b-form-input size="sm" id="nroTurno" type="text" v-on:change="onFiltroChange" v-model="filtro.Turno" value="" placeholder="000"></b-form-input>
                  </b-input-group>                
                </b-col>
                <b-col sm="3" class="text-center">
                  <!-- debajo del boton -->
                </b-col>
              </b-row>
              <b-row class="mt-3">
                  <b-col sm="3">
                    <b-form-input class="form-control form-control-sm float-right" id="fecha" type="date" v-on:change="onFiltroChange" v-model="filtro.fecha" name="fecha" min="01-01-2000"
              max="31-12-3000"></b-form-input>
                  </b-col>
                  <b-col sm="3">
                    <select name="estatusDepo" v-on:change="onFiltroChange" v-model="filtro.estatusDepo" id="estatusDepo" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('estatusDepo') }">
                        <option value="0">Estatus Deposito</option>
                        <option value="1">Por Depositar</option>
                        <option value="2">Depositado</option>
                    </select>                    
                  </b-col>
                  <b-col sm="3">               
                    <select name="formaPagoId" v-on:change="onFiltroChange" v-model="filtro.formaPagoId" id="formaPagoId" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('formaPagoId') }">
                      <option value="-1">Todos Formas de Pago</option>
                      <option v-for="itemc in formasPago" :value="itemc.id"  v-bind:key="itemc.id">
                          {{itemc.descripcion}}
                      </option>
                    </select>
                  </b-col>                                                                       
              </b-row>
              </b-form-group>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>

    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">Turnos Arqueados</h3>            
            <div class="text-right">
              <a title="Descargar Excel" :href="$gate.getApiUrl()+'Report/DownloadExcelDocument?Fecha='+filtro.fecha" class="btn btn-success btn-md active" role="button" aria-pressed="true"><i class="far fa-file-excel"></i></a>
            </div>            
        </b-card-header>
        <div class="card-body table-responsive p-0">           
          <table class="table table-hover">
            <tbody>
              <tr v-if="filtro.formaPagoId!=-1 && filtroActivo"><th colspan="5"></th><th class="text-right"><h3>{{totalProcesado | tipoMoneda(filtro.formaPagoId)}}</h3></th><th class="text-right"><h3>{{totalDeclarado | tipoMoneda(filtro.formaPagoId)}}</h3></th><th v-if="$gate.isAdmin()"></th><th></th></tr>
              <tr class="thead-light text-center">
                <th>Despositado</th>
                <th v-if="$gate.isAdmin()">Tienda</th>
                <th>Caja</th>
                <th>Turno</th>
                <th>Forma Pago</th>
                <th class="text-right">Procesado</th>
                <th class="text-right">Declarado</th>                        
                <th class="text-right">Diferencia</th>
                <th>Acciones</th>
            </tr>
            <tr class="text-center" v-for="turnoArqueado in turnosArqueados" :key="turnoArqueado.codigoCaja" :class="{'resaltar':turnoArqueado.estatusTurno<5}">
              <td><span :class="{'badge badge-danger':turnoArqueado.estatusArqueo===1,'badge badge-success':turnoArqueado.estatusArqueo===2 }">{{turnoArqueado.estatusArqueo | statusArqueo}}</span></td>
              <!--<td>{{zfill(caja.consecutivo, 6)}}</td>
              <td><span :class="{'badge badge-danger':!caja.facturaAlMayor, 'badge badge-success':caja.facturaAlMayor }">{{caja.facturaAlMayor | factmy}}</span></td>-->
              <td v-if="$gate.isAdmin()">{{turnoArqueado.tiendaId}}</td>
              <td><h3 v-b-popover.hover.top="'Ver Turnos de Caja'" class="micursor" @click="getDetalleCaja(turnoArqueado)"><b-badge variant="primary">{{turnoArqueado.caja}}</b-badge></h3></td>
              <td>{{turnoArqueado.turno}}</td>
              <td><h4 v-b-popover.hover.top="turnoArqueado.formaPagoId==2?'Ver Desglose Dolar':''" class="micursor" @click="verDesgloseDolar(turnoArqueado)">{{turnoArqueado.descripcion}}</h4></td>
              <!--<td ><span :class="{'badge badge-warning':turnoArqueado.estatusTurno===1,'badge badge-primary':turnoArqueado.estatusTurno===2,'badge badge-danger':turnoArqueado.estatusTurno===3, 'badge badge-info':turnoArqueado.estatusTurno===4,'badge badge-success':turnoArqueado.estatusTurno===5 }">{{turnoArqueado.estatusTurno | statusTurno}}</span></td>-->
              <td class="text-right"><h4>{{turnoArqueado.procesado | moneda}}</h4></td>
              <td class="text-right"><h4>{{turnoArqueado.declarado | moneda}}</h4></td>
              <td class="text-right"><h4>{{(turnoArqueado.declarado-turnoArqueado.procesado)  | moneda}}</h4></td>
              <td>
                  <base-button size="sm" title="Ver Turno Arqueado" type="secondary" 
                  @click="procesarCaja(turnoArqueado)"
                  :class="{'disabled':(turnoArqueado.estatusTurno == -1 || turnoArqueado.estatusTurno == 0)}">
                      <i class="fas fa-eye"></i>
                  </base-button>
              </td>
            </tr>
            <tr v-if="turnosArqueados.length === 0">
              <td  class="text-center" colspan="6"> <h2>No hay Información</h2></td>
            </tr>
          </tbody></table>
            <!-- /.card -->
        </div>
        <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination @change="getResults" v-model="currentPage" :per-page="perPage" :total="totalItemsRow"></base-pagination>
        </b-card-footer>
    </b-card>          
          <!--<light-table/>          
          <dark-table/>-->
        </b-col>
      </b-row>
      <div class="mt-5"></div>     
    </b-container>


    
  <b-modal id="modal-multi-3" size="sm" title="Third Modal" ok-only>
    <p class="my-1">Third Modal</p>
  </b-modal>

    <!-- Detalle pago -->
    <b-modal ref="modal-Detalle" hide-backdrop  size="xl" ok-only>
      <template #modal-title>
        <h5 class="modal-title">Detalles Pagos</h5>        
      </template>
      <p>
        <!--Total Dolares: {{detalleMoneda[0].totalMoneda | moneda}} - Total Bolivares: {{detalleMoneda[1].totalMoneda | moneda}}-->
        <b-button v-b-modal.modal-multi-3 size="sm">Open Third Modal</b-button>
      </p>

      <template #modal-footer="{ close }">
        <div class="w-100">          
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="close()"
          >
            Cerrar
          </b-button>
        </div>
      </template>
    </b-modal>
    
    <!-- Detalle Caja -->
    <b-modal ref="modal-Detalle-Caja" hide-backdrop  size="lg" ok-only>
      <template #modal-title>
        <h5 class="modal-title">Detalle Caja: {{CajaSelected.caja}}</h5>        
      </template>
      <template>
        <table class="table table-hover">
                <tbody>                
                <tr class="thead-light text-center">
                  <th>Turno</th>
                  <th>Estatus</th>
                  <th>Fecha Inicial</th>
                  <th>Fecha Final</th>
                  <th class="text-right">Total Neto Bs</th>
                  <th class="text-right">Total Neto Ref</th>
                </tr>
                <tr class="text-center" v-for="dgCaja in detalleCajaArqueo" :key="dgCaja.idTurno" :class="{'resaltar':dgCaja.estatus<5}">
                  <td>{{dgCaja.idTurno}}</td>
                  <td>{{dgCaja.estatus | statusTurno}}</td>
                  <td>{{dgCaja.facturaInicial}}</td>
                  <td>{{dgCaja.facturaFinal}}</td>
                  <td class="text-right">{{dgCaja.totalfacturadobs | moneda}}</td>
                  <td class="text-right">{{dgCaja.totalfacturadodolar | moneda}}</td>
                </tr>
                <tr>
                  <td class="text-right" colspan="4"><h3>Total:</h3></td>
                  <td class="text-right"><h3>{{totalBs | moneda}}</h3></td>
                  <td class="text-right"><h3>{{totalDolar | moneda}}</h3></td>
                </tr>
                  <tr v-if="detalleCajaArqueo.length === 0">
                  <td  class="text-center" colspan="6"> <h2>No hay Información</h2></td>
                </tr>
              </tbody>
        </table>            
      </template>
      <template #modal-footer="{ close }">
        <div class="w-100">          
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="close()"
          >
            Cerrar
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- End Detalle Caja -->

    <!-- Detalle Turno -->
    <b-modal ref="modal-Detalle-Caja" hide-backdrop  size="lg" ok-only>
      <template #modal-title>
        <h5 class="modal-title">Detalle Caja: {{CajaSelected.caja}}</h5>        
      </template>
      <template>
        <table class="table table-hover">
                <tbody>                
                <tr class="thead-light text-center">
                  <th>Turno</th>
                  <th>Estatus</th>
                  <th>Fecha Inicial</th>
                  <th>Fecha Final</th>
                  <th class="text-right">Total Neto Bs</th>
                  <th class="text-right">Total Neto Ref</th>
                </tr>
                <tr class="text-center" v-for="dgCaja in detalleCajaArqueo" :key="dgCaja.idTurno" :class="{'resaltar':dgCaja.estatus<5}">
                  <td>{{dgCaja.idTurno}}</td>
                  <td>{{dgCaja.estatus | statusTurno}}</td>
                  <td>{{dgCaja.facturaInicial}}</td>
                  <td>{{dgCaja.facturaFinal}}</td>
                  <td class="text-right">{{dgCaja.totalfacturadobs | moneda}}</td>
                  <td class="text-right">{{dgCaja.totalfacturadodolar | moneda}}</td>
                </tr>
                <tr>
                  <td class="text-right" colspan="4"><h3>Total:</h3></td>
                  <td class="text-right"><h3>{{totalBs | moneda}}</h3></td>
                  <td class="text-right"><h3>{{totalDolar | moneda}}</h3></td>
                </tr>
                  <tr v-if="detalleCajaArqueo.length === 0">
                  <td  class="text-center" colspan="6"> <h2>No hay Información</h2></td>
                </tr>
              </tbody>
        </table>            
      </template>
      <template #modal-footer="{ close }">
        <div class="w-100">          
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="close()"
          >
            Cerrar
          </b-button>
        </div>
      </template>
    </b-modal>
    <!-- End Detalle Turno -->

      <!-- desglose pagos cajera -->
    <b-modal ref="modal-dpc" size="sm" title="Agregar Detallado" ok-only>
      <b-form-textarea
      id="textarea"
      v-model="form.observacion"
      placeholder="Ingrese Observaciones..."
      rows="3"
      max-rows="6"
      ></b-form-textarea>
    </b-modal>

      <!-- desglose pagos cajera dolar-->
    <b-modal ref="modal-dpc-dolar" size="lg" title="Agregar Detallado Dolar" ok-only>
      <b-row xl="12" md="12">
        <!--<b-card no-body>-->
          <b-col md="6">
          <b-list-group>
            <b-list-group-item  v-for="ded in  detalleEfectivoDolar" :key="ded.denominacion" class="d-flex justify-content-between align-items-center">
              {{ded.denominacion}} -
              <b-badge variant="primary" ><b-form-input @change="calcularMonto(ded)" class="form-control" size="sm" v-model="ded.cantidad" type="text" placeholder="0" :id="'monto_'+ded.denominacion+'_'+ded.moneda"></b-form-input></b-badge>
              {{ded.monto | moneda}}
            </b-list-group-item> <!-- @change="onChangeMonto(mp)" @keydown="onChangeMonto(mp)"-->
          </b-list-group>
          Total Dolares: {{totalGeneralDed | moneda}}                
          </b-col>
          <b-col  md="6">
          <b-list-group>
            <b-list-group-item  v-for="ded in  detalleEfectivoEuro" :key="ded.denominacion" class="d-flex justify-content-between align-items-center">
              {{ded.denominacion}} -
              <b-badge variant="primary" ><b-form-input @change="calcularMonto(ded)" class="form-control" size="sm" v-model="ded.cantidad" type="text" placeholder="0" :id="'monto_'+ded.denominacion+'_'+ded.moneda"></b-form-input></b-badge>
              {{ded.monto | moneda}}
            </b-list-group-item> <!-- @change="onChangeMonto(mp)" @keydown="onChangeMonto(mp)"-->
          </b-list-group>
          Total Euros: {{totalGeneralEur | moneda}}                
          </b-col>          
        <!--</b-card>-->
      </b-row>
      <template #modal-footer="{ close }">
        <div class="w-100">          
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="close()"
          >
            Cerrar
          </b-button>
        </div>
      </template>      
    </b-modal>    

  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
  //import projects from './../../Tables/projects'
  //import cajas from './../../Tables/cajas'
  //import tiendas from './../../Tables/tiendas'
  //import areas from './../../Tables/areas'
  //import detallespago from './../../Tables/detallespago'    
  //import Modal from './../../../components/Modal'
  //import LightTable from "./../../Tables/RegularTables/LightTable";
  //import DarkTable from "./../../Tables/RegularTables/DarkTable";

  export default {
    components: {
      //LightTable,
      //DarkTable,
      //Modal,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      editmode: false,
      filtroActivo:false,
      perPage:80,
      currentPage: 1,
      totalItemsRow:10,
      selected: [], // Must be an array reference!
      options: [
        { text: 'Por Depositar', value: 'orange' },
        { text: 'Depositados', value: 'apple' },
        /*{ text: 'Pineapple', value: 'pineapple' },
        { text: 'Grape', value: 'grape' }*/
      ],      
      form: new Form({
        id: 0,
        tiendaId: 0,
        codigoCaja: '',
        areaId: '',
        monto: 0,
        estatus: true,
      }),
      filtro: new Form({
        Caja: '',
        Turno: 0,
        formaPagoId:'-1',        
        fecha: this.getDate(),        
        estatusDepo:0,
        estatusTurno:0,
        tiendaId:0,
        ordenar:0
      }),
        turnosArqueados:[],
        tiendas:[],
        formasPago:[],
        detalleCajaArqueo:[],
        selectCajas:[],
        selectTienda:[],
        CajaSelected:{},
        detalleEfectivoDolar:[{denominacion:1, cantidad:0, monto:0, moneda: 1},{denominacion:5, cantidad:0, monto:0, moneda: 1},{denominacion:10, cantidad:0, monto:0, moneda: 1},{denominacion:20, cantidad:0, monto:0, moneda: 1},{denominacion:50, cantidad:0, monto:0, moneda: 1},{denominacion:100, cantidad:0, monto:0, moneda: 1}],
        detalleEfectivoEuro:[{denominacion:1, cantidad:0, monto:0, moneda: 2},{denominacion:5, cantidad:0, monto:0, moneda: 2},{denominacion:10, cantidad:0, monto:0, moneda: 2},{denominacion:20, cantidad:0, monto:0, moneda: 2},{denominacion:50, cantidad:0, monto:0, moneda: 2},{denominacion:100, cantidad:0, monto:0, moneda: 2}],
        status: [{value:true, text:"Activo"}, {value:false, text:"Inactivo"}],
      };
    },
    methods: {
      async getResults(page = 1) {
        await axios.get(this.$gate.getApiUrl()+'Contabilidad/resumen/caja/formapago?page='+page+'&perPage='+this.perPage,{ params: this.filtro })
        .then(({ data }) => {
          if(data){
            this.turnosArqueados = data.data.resumenTurnoFp;
            this.totalItemsRow = data.data.totalrow;
          }else{
            this.turnosArqueados =[];
          }
        }).catch( e => {
            /* si el token es invalido o esta vencido */
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");             
            }
        });
      },
      procesarCaja(dataCaja){
        this.$router.push("turnos?Caja="+dataCaja.caja+"&fecha="+this.filtro.fecha);
      },
      zfill(number, width=6) {
          var numberOutput = Math.abs(number); /* Valor absoluto del número */
          var length = number.toString().length; /* Largo del número */ 
          var zero = "0"; /* String de cero */  
          
          if (width <= length) {
              if (number < 0) {
                  return ("-" + numberOutput.toString()); 
              } else {
                  return numberOutput.toString(); 
              }
          } else {
              if (number < 0) {
                  return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
              } else {
                  return ((zero.repeat(width - length)) + numberOutput.toString()); 
              }
          }
      },          
      async onChangeSelectCajas(){
        this.filtroActivo = true;
        await axios.get(this.$gate.getApiUrl()+"Caja/tienda/"+this.filtro.tiendaId).then(({ data }) => {this.selectCajas = data;/*this.getSelectTienda();*/ }); 
      },      
      getDate(){
        var currentDate = new Date();
        return currentDate.getFullYear()+"-"+(currentDate.getMonth()<9?"0"+(currentDate.getMonth()+1):(currentDate.getMonth()+1))+"-"+(currentDate.getDate()<10?"0"+currentDate.getDate():currentDate.getDate());
      },
      aplicarFiltro(){
        this.setFilters();
        //if(this.$gate.isAdmin()){
          let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: true,
            loader: 'dots',
          });
          this.getResults();
          loader.hide();     
      },       
      resetFiltro(){
        this.filtro.reset();      
        this.filtroActivo = false;
        localStorage.removeItem('filter');
      },
      setFilters(){
        let parsed = JSON.stringify(this.filtro);        
        localStorage.setItem('filter', parsed);
        //console.log()
      },
      getFilters(){
        return JSON.parse(localStorage.getItem('filter'));  
      },    
      onFiltroChange(){
        this.filtroActivo = true;
      },
      async getDesgloseDolar(turno){
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DesgloseDolarArqueoByTurno/"+turno).then(({ data }) => {
          this.detalleEfectivoDolar = data.data.desgloseDolar;
          this.detalleEfectivoEuro = data.data.desgloseEuro;
        });
      },      
      verDesgloseDolar(turnoArqueado){
        if(turnoArqueado.formaPagoId == 2){
          this.$refs['modal-dpc-dolar'].show();
          this.getDesgloseDolar(turnoArqueado.turno);
        }
      },    
      detalleCaja(caja){
        this.$refs['modal-Detalle'].show();
      },
      async getDetalleCaja(cajaData){
        this.CajaSelected = cajaData;
        await axios.get(this.$gate.getApiUrl()+"cajaadministrativa/facturadoxturnoxfecha?fechaActual="+this.filtro.fecha + "&caja=" + cajaData.caja + "&page=1&perPage=10" )
          .then( ({ data }) => {
              this.detalleCajaArqueo = data.data;/*this.getSelectTienda();*/
            }); 
            this.$refs['modal-Detalle-Caja'].show();
      },       
      editModal(caja){
        this.editmode = true;
        this.form.reset();
        this.$refs['modal-1'].show();
        //$('#addNew').modal('show');
        this.form.fill(caja);
      },
      updateCaja(){
        console.log('Actualizar Data');
        this.hideModal();
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      createCaja(){

      },
      totalDetalle(pagoFacturaElectronico){

      },
      getArea(areaId){
        //console.log(this.areas)
        if(this.areas.length >0){
          let itemEnc = this.areas.find(m => m.value === areaId);
          if(areaId>=0){
            //console.log(itemEnc)
            //return itemEnc.text;
          }else{ 
            return "---";
          }
        }
      },
      onChangeTiendaF(){

      },      
      onChangeTienda(){

      },
      getTienda(tiendaId){        
        if(this.tiendas.length >0){
          let itemEnc = this.tiendas.find(m => m.id === tiendaId);
          if(tiendaId>=0){
            return itemEnc.nombre;
          }else{ 
            return "---";
          }
        }
      },
      getSelectTienda(){
        this.tiendas.forEach(element => {
          if(element.id>0){
            let data = {value:element.id, text:element.nombre};
            this.selectTienda.push(data);          
          }            
        });
      },
      loadTurnosArqueados(){
        let datafilter = this.getFilters();
        this.filtro.fecha = datafilter!==null?datafilter.fecha:this.getDate();
        axios.get(this.$gate.getApiUrl()+"Tienda").then(({ data }) => {this.tiendas = data; this.getSelectTienda(); });
        axios.get(this.$gate.getApiUrl()+"FormaPago").then(({ data }) => {this.formasPago = data; });                
        this.getResults();        
      },
    },
    computed: {
      totalProcesado: function(){
        let total = [];

        Object.entries(this.turnosArqueados).forEach(([key, val]) => {
            if(val.formaPagoId == this.filtro.formaPagoId)
            total.push(val.procesado) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },     
      totalDeclarado: function(){
        let total = [];

        Object.entries(this.turnosArqueados).forEach(([key, val]) => {
          if(val.formaPagoId == this.filtro.formaPagoId)
            total.push(val.declarado) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalBs: function(){
        let total = [];

        Object.entries(this.detalleCajaArqueo).forEach(([key, val]) => {
            total.push(val.totalfacturadobs) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },     
      totalDolar: function(){
        let total = [];

        Object.entries(this.detalleCajaArqueo).forEach(([key, val]) => {
            total.push(val.totalfacturadodolar) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralEur: function(){
        let total = [];

        Object.entries(this.detalleEfectivoEuro).forEach(([key, val]) => {
           //if(val.formaPagoId==1 || val.formaPagoId==3 || val.formaPagoId==7)
            total.push(val.monto) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);
      },
      totalGeneralDed: function(){
        let total = [];

        Object.entries(this.detalleEfectivoDolar).forEach(([key, val]) => {
           //if(val.formaPagoId==1 || val.formaPagoId==3 || val.formaPagoId==7)
            total.push(val.monto) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);
      },
    },    
    mounted(){
      this.loadTurnosArqueados();
    },    
    created(){
      //this.loadTurnosArqueados();
    }
  };
</script>
<style>
.scrollDiv{
  	overflow-y: scroll;
    	height: 300px;	
}
.resaltar{
  font-weight: bold;
  background: #ffcdd2;
}
.micursor {cursor: pointer; cursor: hand;}
</style>
